export const handleMenuItemClick = async (
    navigate: (to: string) => void,
    fullTo: string,
    e: React.MouseEvent,
) => {
    e.preventDefault();
    if (window.onNavigateForRazor) {
        await window.onNavigateForRazor();
        window.onNavigateForRazor = null;
    }

    navigate(fullTo);
};
